export default "__VITE_ASSET__BpUwZ89Q__"